// src/pages/TenantManagement/TenantPagination.tsx
import React from 'react';
import { Row, Col, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentPage, setPageSize } from 'slices/tenantManagement/reducer';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('tenant_management');

const TenantPagination: React.FC = () => {
  const dispatch = useDispatch();
  const { pagination } = useSelector((state: any) => state.TenantManagement);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= pagination.totalPages) {
      dispatch(setCurrentPage(page));
    }
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setPageSize(parseInt(e.target.value)));
  };

  if (pagination.totalItems === 0) return null;

  const startItem = (pagination.currentPage - 1) * pagination.pageSize + 1;
  const endItem = Math.min(
    pagination.currentPage * pagination.pageSize,
    pagination.totalItems
  );

  // Generate page numbers
  const pageNumbers: number[] = [];
  const maxPagesToShow = 5;
  let startPage = Math.max(1, pagination.currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(pagination.totalPages, startPage + maxPagesToShow - 1);

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <Row className="align-items-center mt-4">
      {/* <Col sm={6}>
        <div className="text-muted">
          Hiển thị <span className="fw-semibold">{startItem}</span> đến{' '}
          <span className="fw-semibold">{endItem}</span> trong tổng số{' '}
          <span className="fw-semibold">{pagination.totalItems}</span> bản ghi
        </div>
      </Col> */}
      <Col sm={6}>
        <div className="d-flex align-items-center gap-3">
          {/* Page size selector */}
          <div className="d-flex align-items-center">
            <span className="text-muted me-2">{st('hien_thi_text')}</span>
            <select
              className="form-select form-select-sm"
              style={{ width: 'auto' }}
              value={pagination.pageSize}
              onChange={handlePageSizeChange}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <span className="text-muted ms-2">{st('ban_ghi_text')}</span>
          </div>
        </div>
      </Col>
      <Col sm={6}>

          {/* Pagination */}
        <div className="d-flex justify-content-end">
          <Pagination className="pagination-separated mb-0">
            <PaginationItem disabled={pagination.currentPage === 1}>
              <PaginationLink
                previous
                onClick={() => handlePageChange(pagination.currentPage - 1)}
              >
              <i className="ri-arrow-left-line"></i>
              </PaginationLink>
            </PaginationItem>

            {startPage > 1 && (
              <>
                <PaginationItem>
                  <PaginationLink onClick={() => handlePageChange(1)}>
                    1
                  </PaginationLink>
                </PaginationItem>
                {startPage > 2 && (
                  <PaginationItem disabled>
                    <PaginationLink>...</PaginationLink>
                  </PaginationItem>
                )}
              </>
            )}

            {pageNumbers.map((page) => (
              <PaginationItem key={page} active={page === pagination.currentPage}>
                <PaginationLink onClick={() => handlePageChange(page)}>
                  {page}
                </PaginationLink>
              </PaginationItem>
            ))}

            {endPage < pagination.totalPages && (
              <>
                {endPage < pagination.totalPages - 1 && (
                  <PaginationItem disabled>
                    <PaginationLink>...</PaginationLink>
                  </PaginationItem>
                )}
                <PaginationItem>
                  <PaginationLink
                    onClick={() => handlePageChange(pagination.totalPages)}
                  >
                    {pagination.totalPages}
                  </PaginationLink>
                </PaginationItem>
              </>
            )}

            <PaginationItem disabled={pagination.currentPage === pagination.totalPages}>
              <PaginationLink
                next
                onClick={() => handlePageChange(pagination.currentPage + 1)}
              >
              <i className="ri-arrow-right-line"></i>
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </Col>
    </Row>
  );
};

export default TenantPagination;